import { render, staticRenderFns } from "./AddOrSeeRoleModal.vue?vue&type=template&id=4bde0692&scoped=true&"
import script from "./AddOrSeeRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddOrSeeRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrSeeRoleModal.vue?vue&type=style&index=0&id=4bde0692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde0692",
  null
  
)

export default component.exports